import FixaPill from "@coworker/apprestructured/src/shared/wrappers/FixaPill/FixaPill";
import {
  getWeekdayNumber,
  getWeekdays,
} from "@coworker/apprestructured/src/task-management/components/ScheduleTask/helper";
import { WeeklyRecurrenceDay } from "@coworker/apprestructured/src/task-management/types/Schedule";
import styles from "./Days.module.css";
import { useTranslation } from "@coworker/locales";

type DaysProps = {
  start: string | null;
  selectedWeeklyRecurrenceDays: WeeklyRecurrenceDay[];
  onDaysChange: (days: WeeklyRecurrenceDay[]) => void;
};

export const Days = (props: DaysProps) => {
  const { t } = useTranslation();
  const weekdays = getWeekdays(t);
  const startWeekdayNumber = props.start ? getWeekdayNumber(props.start) : null;
  return (
    <div data-testid="weekdays" className={styles["days"]}>
      {weekdays.map((day) => {
        return (
          <FixaPill
            data-testid={`weekday-${day.weekdayNumber}`}
            key={day.weekdayNumber}
            label={day.shortFormattedWeekday}
            disabled={!props.start}
            size="small"
            onClick={() => {
              // Ignore clicks on start weekday number
              if (day.weekdayNumber === startWeekdayNumber) {
                return;
              }
              if (
                props.selectedWeeklyRecurrenceDays.includes(day.weekdayNumber)
              ) {
                props.onDaysChange(
                  props.selectedWeeklyRecurrenceDays.filter(
                    (d) => d !== day.weekdayNumber
                  )
                );
              } else {
                props.onDaysChange(
                  [
                    ...props.selectedWeeklyRecurrenceDays,
                    day.weekdayNumber,
                  ].sort()
                );
              }
            }}
            selected={props.selectedWeeklyRecurrenceDays.includes(
              day.weekdayNumber
            )}
          />
        );
      })}
    </div>
  );
};
